const moment = require("moment");

export const getMessage = (todoData, performanceTabIndex, isCustomer) => {
  const performanceGroup = todoData?.todo_performance_groups[0];
  const oldestPerformance = performanceGroup.todo_performances?.sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );
  const name =
    oldestPerformance[0]?.perform_user_name ||
    oldestPerformance[0]?.perform_collaborator_name ||
    "";
  const date = moment(oldestPerformance[0]?.date).format(
    "DD MMM, YYYY - hh:mm A"
  );

  let message = "User has already performed this To Do.";

  if (name && date && !isCustomer) {
    message = `<strong>${name}</strong> has selected a performance date as ${date}.`;
  } else {
    message = `To Do Performed at ${date}.`;
  }

  return message;
};


export const getBannerMessage = (todoData, performanceTabIndex, isCustomer) => {
  const performanceGroup = todoData?.todo_performance_groups[0];
  const oldestPerformance = performanceGroup.todo_performances?.sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  );
  const date = moment(oldestPerformance[0]?.createdAt).format(
    "DD MMM, YYYY - hh:mm A"
  );

  let message = "To Do already performed";

  if (date && !isCustomer) {
    message = `To Do Marked As Completed At ${date}.`;
  }

  return message;
};